module.exports = __webpack_public_path__ + "img/av269.cff2fba7.png";